export default "__VITE_ASSET__3zuDtwwj__"